import { RichTextFieldStrapiProps } from '@/decodo/components/atoms/RichTextField/RichTextFieldStrapi';

export function getHeadingsText(data: RichTextFieldStrapiProps[]) {
  const headingsText: string[] = [];

  data.forEach((slice) => {
    if (!slice?.text) return;

    slice.text.forEach((content) => {
      if (content.type === 'heading' && content.level === 2) {
        const combinedH2 = content.children
          .map((child) => ('text' in child ? child?.text : ''))
          .join(' ');
        headingsText.push(combinedH2);
      }
    });
  });

  return headingsText;
}

export function getRichTextFieldHeadingLevel2(data: RichTextFieldStrapiProps) {
  const headingsText: string[] = [];

  data?.text?.forEach((content) => {
    if (content.type === 'heading' && content.level === 2) {
      const combinedH2 = content.children
        .map((child) => ('text' in child ? child?.text : ''))
        .join(' ');
      headingsText.push(combinedH2);
    }
  });

  return headingsText;
}
